import _ from "lodash";

export function collateBot(state, field) {
  const bots = Object.keys(state);

  const result = [];

  for (const name of bots) {
    let values = _.get(state[name], field);
    if (!Array.isArray(values)) values = Object.values(values);

    result.push(
      ...values.map(v => ({
        ...v,
        bot: name
      }))
    );
  }
  return result;
}

export function find(state, fields) {
  const keys = Object.keys(state);

  for (const k of keys) {
    const val = _.get(state[k], fields);
    if (val) return val;
  }

  return undefined;
}
